import { Box, Link, SxProps } from '@mui/material'
import { useTheme } from 'react-admin'
import Logo from '@/icons/logo.svg?react'

const Footer = ({ sx }: { sx?: SxProps }) => {
  const [themeMode] = useTheme()

  return (
    <Box
      sx={{
        height: '48px',
        px: '1rem',
        backgroundColor: themeMode === 'light' ? 'white' : '#666666',
        boxShadow:
          '0px 1px 1px 0px rgba(0,0,0,0.14),inset 0px 1px 3px 0px rgba(0,0,0,0.12)',
        display: 'flex',
        color: themeMode === 'light' ? 'rgba(0, 0, 0, 0.5)' : 'white',
        alignItems: 'center',
        gap: '2rem',
        justifyContent: 'space-between',
        fontSize: '0.8rem',
        ...sx
      }}
    >
      <Link href="/" sx={{ color: 'primary.main', textDecoration: 'none' }}>
        <Logo
          style={{
            width: '200px',
            verticalAlign: 'text-bottom',
            marginRight: '0.5rem'
          }}
        />
        © 2025
      </Link>

      <Box sx={{ display: 'flex', gap: '0.5rem' }}>
        <Link href="https://www.stackcommerce.com/privacy/" sx={{ mt: '5px' }}>
          Privacy Policy
        </Link>
        <Link
          href="https://www.stackcommerce.com/site-terms/"
          sx={{ mt: '5px' }}
        >
          Terms
        </Link>
      </Box>
    </Box>
  )
}

export default Footer
